/**
 * Loading Spinner Component
 * Reusable loading indicator with size variants
 */
import React from 'react';
import './LoadingSpinner.css';

/**
 * Loading spinner with customizable size
 * @param {Object} props - Component props
 * @param {string} props.size - Size variant: 'small', 'medium', 'large'
 * @param {string} props.color - Custom color (optional)
 * @param {string} props.className - Additional CSS classes
 */
const LoadingSpinner = ({ size = 'medium', color, className = '' }) => {
  const sizeClass = `spinner-${size}`;
  
  return (
    <div 
      className={`loading-spinner ${sizeClass} ${className}`}
      style={color ? { '--spinner-color': color } : undefined}
      role="status"
      aria-label="Loading"
    >
      <div className="spinner-circle"></div>
      <span className="visually-hidden">Loading...</span>
    </div>
  );
};

export default LoadingSpinner;
